angular.module('FlexyBeautyApp.services')
    .factory('WebsiteConstants', [
        function() {
            return {
                checkoutDisplaySteps: {
                    emailValidation: "emailValidation",
                    sms: "sms",
                    identity: "identity",
                    recap: "recap",
                    card: 'card',
                    connect: 'connect'
                }
            }
        }
    ]);



// WEBPACK FOOTER //
// ./js/constants/WebsiteConstants.js